export default __webpack_public_path__ + "static/media/wooden_key_vard.a002455c.jpeg";